/**
 * Standard display format for outcome keys in pickers (redialing, scripts, etc.).
 * `no-answer` → `No Answer`; underscores treated like hyphens.
 */
export function formatOutcomeKeyLabel(key: string): string {
  return key
    .trim()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
